import { ChangeEvent, useState } from 'react'
import { goalMaps } from '../consts/goal_maps'

export default function GoalDropdown({
  handleGoalChange,
  goalValue,
}: {
  handleGoalChange: (
    _event: ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => void
  goalValue: string
}): React.ReactElement {
  const populateTextField = (
    event: ChangeEvent<HTMLSelectElement | HTMLSelectElement>,
  ) => {
    setGoalTextEnabled(event.target.value === 'custom')
    handleGoalChange(event)
  }

  const [goalTextEnabled, setGoalTextEnabled] = useState(false)

  const filteredGoalValues = (goalValueIn: string) => {
    let filteredKey: string = ''

    Object.keys(goalMaps).forEach((goalKey) => {
      if (goalMaps[goalKey] === goalValueIn) {
        filteredKey = goalMaps[goalKey]
      }
    })

    if (goalValueIn.length && !filteredKey.length) {
      filteredKey = 'custom'
    }

    return filteredKey
  }

  return (
    <>
      <select
        value={filteredGoalValues(goalValue)}
        onChange={populateTextField}
      >
        <option disabled={true} value={''} key={null}>
          Select a goal
        </option>
        {Object.keys(goalMaps).map((goal) => {
          return (
            <>
              <option
                value={goalMaps[goal] ? goalMaps[goal].toString() : 'custom'}
                key={goalMaps[goal]}
              >
                {goal}
              </option>
            </>
          )
        })}
      </select>
      <div
        style={{
          display:
            goalTextEnabled && goalValue !== '' ? 'inline-block' : 'none',
        }}
      >
        <input
          disabled={!goalTextEnabled}
          type="text"
          onChange={handleGoalChange}
          value={goalValue}
        ></input>
      </div>
    </>
  )
}
